import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      {/* 订阅区 */}
      <div className="border-b border-background-200">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-6 px-4 py-10 md:px-6 lg:grid-cols-2">
          <div>
            <h2 className="text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              订阅<b className="font-display font-normal text-primary-600">娱乐爆料</b>
            </h2>
            <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
              每天一份，把最新鲜的明星动态、独家爆料和现场直击打包送到你邮箱，让你时刻走在吃瓜最前线。
            </p>
          </div>
          <div className="lg:justify-self-end lg:w-full lg:max-w-md">
            <NewsletterForm />
          </div>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-10 md:grid-cols-4 md:px-6">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-flashlight-fill text-sm"></i>
            </span>
            <span className="text-lg font-black text-foreground-950">
              娱乐<span className="text-primary-600">爆料</span>
            </span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            独家首发，第一手娱乐资讯抢先看。每日更新，带你第一时间掌握娱乐圈大小事。
          </p>
        </div>
        <nav aria-label="内容栏目">
          <h3 className="text-sm font-bold text-foreground-950">内容栏目</h3>
          <ul className="mt-3 space-y-2 text-sm text-foreground-600">
            <li><Link className="hover:text-primary-600" to="/category/exclusive">独家爆料</Link></li>
            <li><Link className="hover:text-primary-600" to="/category/stars">明星动态</Link></li>
            <li><Link className="hover:text-primary-600" to="/category/drama">热剧追踪</Link></li>
          </ul>
        </nav>
        <nav aria-label="更多栏目">
          <h3 className="text-sm font-bold text-foreground-950">更多栏目</h3>
          <ul className="mt-3 space-y-2 text-sm text-foreground-600">
            <li><Link className="hover:text-primary-600" to="/category/music">音乐现场</Link></li>
            <li><Link className="hover:text-primary-600" to="/category/variety">综艺圈</Link></li>
            <li><Link className="hover:text-primary-600" to="/about">关于我们</Link></li>
          </ul>
        </nav>
        <div className="col-span-2 md:col-span-1">
          <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
          <ul className="mt-3 space-y-2 text-sm text-foreground-600">
            <li>
              <a className="inline-flex items-center gap-2 hover:text-primary-600" href="mailto:contact@entertainment.example.com">
                <i className="ri-mail-line"></i>contact@entertainment.example.com
              </a>
            </li>
            <li>
              <a className="inline-flex items-center gap-2 hover:text-primary-600" href="https://weibo.com" rel="nofollow noopener" target="_blank">
                <i className="ri-weibo-fill"></i>@娱乐爆料官方
              </a>
            </li>
            <li>
              <a className="inline-flex items-center gap-2 hover:text-primary-600" href="https://weixin.qq.com" rel="nofollow noopener" target="_blank">
                <i className="ri-wechat-fill"></i>娱乐爆料
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {year} 娱乐爆料 · 独家首发，第一手资讯抢先看</p>
          <p className="flex items-center gap-1">
            本站内容仅供资讯分享与娱乐参考
            <span className="mx-1 text-foreground-300">|</span>
            图文版权归原作者所有
          </p>
        </div>
      </div>
    </footer>
  );
}